<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <div class="font-weight-bold">
                Dados do Cliente
            </div>
            <b-button @click="canShow = !canShow" variant="default" size="sm">
                <i class="fas fa-minus" v-if="canShow"></i>
                <i class="fas fa-plus" v-else></i>
            </b-button>
        </div>
        <div class="card-body" v-show="canShow">
            <customer-form />
        </div>
    </div>
</template>

<script>
import CustomerForm from './Form';

export default {
    components: {
        CustomerForm
    },
    data() {
        return {
            modeEdition: true,
            canShow: false
        }
    }
}
</script>

<style scoped>

</style>
